"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AppStateConstants_1 = require("../../types/AppStateConstants");
const localStorageSetData = ({ entryVars: { updates: updateInstructions, }, callbacks, executeProcesses, functionId, processor, store, }) => {
    if (!Array.isArray(updateInstructions)) {
        processor.root.alert('Invalid update instruction when setting local data', `${updateInstructions}`);
        executeProcesses(functionId, callbacks.errorProcess, 'Invalid update instructions');
        return;
    }
    const updates = updateInstructions
        .reduce((updatesAccum, updateInstruction) => {
        const lastItemIndex = updateInstruction.length - 1;
        const updateInfo = updateInstruction[lastItemIndex];
        const pathArray = updateInstruction
            .filter((_, index) => index !== lastItemIndex);
        return Object.assign(Object.assign({}, updatesAccum), { [pathArray.join('/')]: updateInfo });
    }, {});
    store.dispatch({
        type: AppStateConstants_1.AppStateConstants.LOCAL_STORAGE_APPLY_UPDATES,
        payload: updates,
    });
    executeProcesses(undefined, callbacks.successProcess);
};
exports.default = localStorageSetData;
